import { memo, useId } from "react"
import type { FC, ReactElement } from "react"

import isEmpty from "lodash-es/isEmpty"
import isString from "lodash-es/isString"
import map from "lodash-es/map"

import { type TScreenBreakpoints, useScreenBreakpoints } from "@/3514/hooks"
import { propsAreEqual } from "@/3514/utils"

import { coachingChatStyles as chatStyles } from "../styles"
import { ECoachingChatSummaryCardMode as EMode, type TCoachingChatSummaryCard as TModel } from "../types"

import { CoachingChatSummaryCard as Card } from "./coaching-chat.summary-card.component"

type TProps = { cards: TModel[]; mode?: EMode }

const {
    conversation: { summaryCards: classes }
} = chatStyles

const Cards: FC<TProps> = ({ cards, mode = EMode.BuildInChat }: TProps): ReactElement => {
    const containerId: string = useId()

    const breakpoints: TScreenBreakpoints = useScreenBreakpoints()

    return (
        <div className={classes.parentContainer(mode, breakpoints.xl || breakpoints.xxl)}>
            {map<TModel, ReactElement>(
                cards,
                (c: TModel, _idx: number, { length }: TModel[]): ReactElement =>
                    isEmpty(c.content) || !isString(c.content) ? null : (
                        <Card {...c} mode={mode} cardsAmount={length} key={`s-c-${c.title}-${containerId}`} />
                    )
            )}
        </div>
    )
}

const MemoizedCards: FC<TProps> = memo<TProps>(Cards, propsAreEqual)

MemoizedCards.displayName = "CoachingChatSummaryCards"

export { MemoizedCards as CoachingChatSummaryCards }
